// @ts-strict-ignore
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { Connection } from '@3d-scene/model3d/connection';
import { Rectangle3D } from '@3d-scene/model/rectangle-3d';
import { Matrix4, Vector3 } from 'three';
import { MathUtils } from '@3d-scene/common/util/math-utils';

export class ConnectArticleHelper {

  public static connectArticlesByCubes(containers: ArticleContainer[], acceptingCube: Connection, givingCube: Connection,
    applyRotaion: boolean = true): void {
    const acceptingRectangle: Rectangle3D = acceptingCube.compositionRectangle;
    const givingRectangle: Rectangle3D = givingCube.compositionRectangle;

    let rotMatrix: Matrix4;
    if (applyRotaion) {
      rotMatrix = MathUtils.getRotationMatrix(givingRectangle.toFace(), acceptingRectangle.toFace());
    }
    const givingMiddlePoint: Vector3 = this.calculateGivingMiddlePoint(acceptingRectangle, givingRectangle, rotMatrix);

    this.connectArticleContainers(containers, rotMatrix, givingMiddlePoint);
  }

  public static calculateGivingMiddlePoint(acceptingRectangle: Rectangle3D, givingRectangle: Rectangle3D, rotMatrix: Matrix4): Vector3 {
    if (!acceptingRectangle || !givingRectangle) {
      return null;
    }
    let givingMiddlePoint: Vector3 = MathUtils.calculateMiddlePointByRectangle(givingRectangle);
    if (rotMatrix) {
      givingMiddlePoint = MathUtils.rotate([givingMiddlePoint], rotMatrix)[0];
    }
    return MathUtils.calculateMiddlePointByRectangle(acceptingRectangle).clone().sub(givingMiddlePoint);
  }

  public static connectArticleContainers(containers: ArticleContainer[], rotationMatrix: Matrix4, offset: Vector3): void {
    if (!containers) {
      return;
    }
    for (const container of containers) {
      this.connectContainer(container, rotationMatrix, offset);
    }
  }

  public static connectContainer(container: ArticleContainer, rotationMatrix: Matrix4, offset: Vector3): void {
    if (rotationMatrix) {
      container.applyMatrix4(rotationMatrix);
    }

    container.moveTo(container.position.x + offset.x, container.position.y + offset.y, container.position.z + offset.z);
  }
}
